import {StyleSheet, ScrollView, ViewStyle, StyleProp, View} from 'react-native';
import {NativeTouchableOpacity} from '@/components/basic/touchable-opacity';
import Text from '@/components/basic/text';
import React from 'react';
import theme from '@/style';
import {PrizeItem} from '../mix-lottery-service';

export interface PrizeTabProps {
  tabs: PrizeItem[];
  onChange?: (id: number) => void;
  selectPrize?: number;
  style?: StyleProp<ViewStyle>;
}

const PrizeTab = ({
  tabs = [
    {
      id: 1,
      name: '1st-prize',
    },
    {
      id: 2,
      name: '2nd-prize',
    },
  ],
  onChange,
  selectPrize = 1,
  style,
}: PrizeTabProps) => {
  if (typeof document !== 'undefined') {
    return (
      <div style={{...stylesWeb.wrap, ...(style as React.CSSProperties)}}>
        <div style={stylesWeb.container}>
          {tabs.map((item, _i) => {
            const isActive = selectPrize === item.id;
            return (
              <button
                key={_i}
                onClick={() => onChange?.(item.id)}
                style={{
                  ...stylesWeb.tabItem,
                  ...(isActive ? stylesWeb.active : null),
                }}
                type="button">
                <span
                  style={{
                    ...stylesWeb.tabText,
                    ...(isActive
                      ? stylesWeb.tabTextActive
                      : stylesWeb.tabTextInactive),
                    color: isActive
                      ? theme.basicColor.white
                      : theme.fontColor.accent,
                  }}>
                  {item.name}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <View style={[styles.wrap, style]}>
      <ScrollView
        horizontal
        showsHorizontalScrollIndicator={false}
        contentContainerStyle={styles.contentContainer}
        style={styles.container}>
        {tabs.map((item, _i) => (
          <NativeTouchableOpacity
            key={_i}
            onPress={() => onChange?.(item.id)}
            style={[styles.tabItem, selectPrize === item.id && styles.active]}>
            <Text
              color={
                selectPrize === item.id
                  ? theme.basicColor.white
                  : theme.fontColor.accent
              }
              fontWeight={selectPrize === item.id ? '700' : '500'}
              size="medium">
              {item.name}
            </Text>
          </NativeTouchableOpacity>
        ))}
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  wrap: {
    backgroundColor: '#F7F9FF',
    borderTopColor: '#D8E0EA',
    borderBottomColor: '#D8E0EA',
    borderTopWidth: 1,
    borderBottomWidth: 1,
    paddingHorizontal: 12,
    paddingVertical: 8,
  },
  container: {
    backgroundColor: '#F7F9FF',
  },
  contentContainer: {
    gap: 10,
  },
  tabItem: {
    minWidth: 82,
    height: 30,
    paddingHorizontal: 12,
    borderRadius: 999,
    alignItems: 'center',
    justifyContent: 'center',
  },
  active: {
    backgroundColor: '#5F6975',
  },
});

const stylesWeb: Record<string, React.CSSProperties> = {
  wrap: {
    backgroundColor: '#F7F9FF',
    borderTop: '1px solid #D8E0EA',
    borderBottom: '1px solid #D8E0EA',
    padding: '0.5rem 0',
    overflowX: 'auto',
    overflowY: 'hidden',
    boxSizing: 'border-box',
  },
  container: {
    display: 'inline-flex',
    gap: '0.625rem',
    minWidth: '100%',
    padding: '0 0.75rem',
    boxSizing: 'border-box',
  },
  tabItem: {
    minWidth: '5.125rem',
    height: '1.875rem',
    padding: '0 0.75rem',
    borderRadius: '9999px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  },
  tabText: {
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
  },
  tabTextActive: {
    fontWeight: 700,
  },
  tabTextInactive: {
    fontWeight: 500,
  },
  active: {
    backgroundColor: '#5F6975',
  },
};

export default PrizeTab;
